// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"05967c6a","436":"c58c9c8e","453":"f394a27d","501":"661b35b4","606":"26ad9c40","821":"9a0be02e","925":"3dfb07cc","969":"59d059b5"}[chunkId] + ".chunk.js";
};